module.exports = __webpack_public_path__ + "img/1188.df68d016.gif";